import * as React from 'react';

const SvgCloseCircle = (props) => (
  <svg
    width={64}
    height={64}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M32.003 5.333C17.309 5.333 5.336 17.307 5.336 32c0 14.693 11.973 26.667 26.667 26.667 14.693 0 26.666-11.974 26.666-26.667 0-14.693-11.973-26.667-26.666-26.667Zm8.96 32.8a2.012 2.012 0 0 1 0 2.827c-.4.4-.907.587-1.414.587a1.978 1.978 0 0 1-1.413-.587l-6.133-6.133-6.134 6.133c-.4.4-.906.587-1.413.587a1.978 1.978 0 0 1-1.413-.587 2.012 2.012 0 0 1 0-2.827L29.176 32l-6.133-6.133a2.012 2.012 0 0 1 0-2.827 2.012 2.012 0 0 1 2.826 0l6.134 6.133 6.133-6.133a2.012 2.012 0 0 1 2.827 0 2.012 2.012 0 0 1 0 2.827L34.829 32l6.134 6.133Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgCloseCircle;
